<template>
	<div class="tab-set-layout">
		<!-- visible at desktop breakpoints -->
		<TabSet class="tab-set-layout__tabs"
			:disabled="disabled"
			:tabs="tabs"
			@select="$emit( `select`, $event )"
		/>
		<!-- visible at mobile breakpoints -->
		<VariableSegmentedButton
			class="tab-set-layout__buttons"
			:disabled="disabled"
			:segments="tabs"
			@change="$emit( `select`, $event )"
		/>
	</div>
</template>

<script>
import {
	TabSet,
	VariableSegmentedButton
} from "@teaming/common-ui";

export default {
	name: "GoalTabSet",
	emits: [ "select", ],
	components: {
		TabSet,
		VariableSegmentedButton,
	},
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
		/** [ { id:String, label:String, isActive:Boolean, disabled:Boolean, [count:Number], }, ... ] */
		tabs: {
			type: Array,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
$tabSetLayoutBorderColor: $color1-200;

.tab-set-layout__tabs {
	display: none;
	border-bottom: 0.0625rem solid $tabSetLayoutBorderColor;

	@include for-size('md') {
		display: flex;
	}
}

.tab-set-layout__buttons {
	display: flex;

	@include for-size('md') {
		display: none;
	}
}
</style>
